import { render, staticRenderFns } from "./receive.vue?vue&type=template&id=06e8de32&"
import script from "./receive.vue?vue&type=script&lang=js&"
export * from "./receive.vue?vue&type=script&lang=js&"
import style0 from "./receive.vue?vue&type=style&index=0&id=06e8de32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports